<template>
    <div class="stories-list" v-if="stories.length">
        <div class="stories-list--heading">
            <div>
                <div class="stories-list--title">
                    Le nostre idee e soluzioni
                </div>
                <div class="stories-list--subtitle">
                    Percorsi guidati alla scoperta del viaggio perfetto per le tue esigenze
                </div>
            </div>
            <div class="stories-list--cta">
                <button-with-icon
                    v-if="show_cta"
                    variant="cta"
                    text="Vedi tutto"
                    :icon="chevron_right"
                    :clicked="() => {
                        router.push({ name: 'category', params: { category_code: category_code } })
                    }"
                />
            </div>
        </div>
        <div class="stories-list--content">
            <slick :ref="'slick-story-'+_uid" :options="slick_options">
                <div v-for="story in stories" v-bind:key="story.postId">
                    <div class="item" @click="() => { router.push({ name: 'post', params: { post_id: story.postId.toString(), title: story.slug } }) }">
                        <div class="item--cover" :style="'background-image:url('+(story.featuredMedia.src ? story.featuredMedia.src : 'https://staging.vadobay.com/assets/sliderHome/1-welfare-aziendale.jpeg')+')'"></div>
                        <div class="item--title" v-html="story.title"></div>
                        <div class="item--excerpt" v-html="story.excerpt"></div>
                    </div>
                </div>
            </slick>   
            <div :prev="_uid" v-html="chevron_left"></div>
            <div :next="_uid" v-html="chevron_right"></div>
        </div>             
    </div>
</template>

<script>
    import Slick from 'vue-slick'
    import Router from '@/router'
    import Bwi from '@/components/atoms/button-with-icon'
    import { chevron_left, chevron_right } from '@/components/svg/chevrons'
    export default {
        name: 'stories-list',
        components: {
            'slick': Slick,
            'button-with-icon': Bwi,
        },
        props: {
            category_code: String,
            stories: {
                type: Array,
                default: () => {
                    return []
                }
            },
            show_cta: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                slick_options:
                {
                    slidesToShow: 5,
                    //arrows: false,
                    prevArrow: '[prev='+this._uid+']',
                    nextArrow: '[next='+this._uid+']',
                    draggable: false,
                    responsive:[
                        {
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 1140,
                            settings: {
                                slidesToShow: 3,
                                //slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 1023,
                            settings: {
                                slidesToShow: 2,
                                //slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                            }
                        },                        
                    ],
                }
            }
        },
        computed: {
        },
        created()
        {
            this.router = Router
            this.chevron_right = chevron_right
            this.chevron_left = chevron_left
        },
        mounted() {            
        },
        methods:{
        },
    }
</script>

<style lang="scss">
.stories-list
{

  a{
    text-decoration: none;
  }

  .item--title {
    color: black;
  }

}
</style>